module.exports = __webpack_public_path__ + "assets/770962917f36aa53c16e7503aa939af3.png";